import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import ScenarioLayout from './components/ScenarioLayout';
import ScenarioReport from './components/ScenarioReport';
import AIInsights from './components/AIInsights';
import { getScenarioDefinitions, SCENARIO_FORM_MAP } from './scenarioConfig';
import { getSavedScenarioOutputApi } from './scenarioApi';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

const ScenarioViewPage = () => {
  const { id } = useParams();
  const { t } = useTranslation();
  const [scenario, setScenario] = useState(null);
  const userInfo = useSelector((state) => state.users.user);

  const form = useForm();
  const reset = form.reset;

  useEffect(() => {
    getSavedScenarioOutputApi(userInfo.usrOrgId, id)
      .then((res) => {
        setScenario(res);
        reset(res.inputs?.values);
      })
      .catch(() => {
        toast.error(t('Failed to load the saved output.'));
      });
  }, [id, reset, userInfo.usrOrgId, t]);

  const scenarioConfig = getScenarioDefinitions(t);
  const config = scenarioConfig[scenario?.model];
  const FormComponent = SCENARIO_FORM_MAP[scenario?.model];

  if (scenario && (!config || !FormComponent)) {
    return <div>{t('Scenario not supported')}</div>;
  }

  const renderViewPage = () => {
    if (!scenario) {
      return null;
    }
    return (
      <>
        <FormProvider {...form}>
          <FormComponent
            mode="view"
            baseline={scenario.baseline}
          />
        </FormProvider>
        <ScenarioReport result={scenario.result} />
        <AIInsights insights={scenario.result?.aiInsights} />
      </>
    );
  }

  return (
    <ScenarioLayout
      mode='view'
      name={scenario?.name}
      title={config?.title ?? t('Loading ...')}
      subtitle={config?.subtitle ?? ''}
      icon={config?.icon ?? 'secondary'}
      color={config?.color ?? 'secondary'}
    >
      {renderViewPage()}
    </ScenarioLayout>
  );
};

export default ScenarioViewPage;
